module.exports = __webpack_public_path__ + "img/wert.9c800cdd.png";